<template>
    <div class="template-login-register">
        <header class="header-animation step1">
            <div class="top">
                <div class="container">
                    <a href="https://simoniot.com">
                        <img src="../../assets/img/logo-dark.png" alt="">
                    </a>

                    <router-link to='/login'>Login</router-link>
                </div>
            </div>

            <div class="lamp"></div>
            <div class="text">Account type</div>

            <div class="particles">
                <vue-particles  color="#17F9F9" linesColor="#16F8F8" :particlesNumber="100"></vue-particles>
            </div>
        </header>

        <div class="contentpage">
            <div class="container-register">
                <div class="step1">
                    <h3>Registration</h3>
                    <h4>Select Account Type</h4>
                    <div class="select-account-type">
                        <router-link class="btn btn-bussines" :to="{name: 'Register', params: { accountType: 'Business'}}">Business Account</router-link>
                        <router-link class="btn btn-maker" :to="{name: 'Register', params: { accountType: 'Maker'}}">Maker Account</router-link>
                    </div>
                </div>
            </div>
        </div>

        <footer>

        </footer>
    </div>
</template>

<script>
    import VueParticles from 'vue-particles'
    import Vue from "vue";
    Vue.use(VueParticles)
    export default {
        name: "RegisterStep1"
    }
</script>

<style lang="scss">

    header.header-animation {
        position: relative;

        .top {
            position: absolute;
            padding: 20px 0;
            top: 0;
            left: 0;
            right: 0;

            .container {
                display: flex;
                justify-content: space-between;
                align-items: center;

                a {
                    color: #fff;
                    font: 400 15px/16px "Roboto", "Arial", sans-serif;
                }
            }
        }

        .lamp {
            position: absolute;
            height: 344px;
            width: 512px;
            margin-left: auto;
            margin-right: auto;
            left: 0;
            right: 0;
            top: 84px;
            background: transparent url("../../assets/img/lamp-login.png") no-repeat center center;
        }

        .text {
            position: absolute;
            width: 100%;
            left: 0;
            right: 0;
            top: 213px;
            background: rgba(1, 24, 38, .84);
            text-align: center;
            font: 700 37px/43px "Roboto", "Arial", sans-serif;
            text-transform: uppercase;
            letter-spacing: 4px;
            color: #fff;
        }
    }

    .particles {
        background-color: #021927;
        height: 480px;
        overflow: hidden;
        #particles-js {
            height: 480px;
        }
    }

    .contentpage {
        background-color: #F8F8F8;
        padding: 43px 0 90px;
        text-align: center;

        .container-register {
            max-width: 520px;
            margin-left: auto;
            margin-right: auto;
            text-align: left;

            h3 {
                font: 700 17px/23px "Roboto", "Arial", sans-serif;
                color: #000000;
            }

            h4 {
                display: block;
                margin-bottom: 30px;
                font: 400 15px/20px "Roboto", "Arial", sans-serif;
            }

            .btn {
                display: block;
                width: 100%;
                height: 56px;
                margin-bottom: 10px;

                background-color: #0088FF;
                font: 400 15px/43px "Roboto", "Arial", sans-serif;
                color: #fff;
                opacity: 0.8;
                transition: all .1s ease-in;

                &:hover {
                    opacity: 1;
                    transition: all .1s ease-in;
                }

                &.btn-maker {
                    background-color: #00F29F;
                }
            }
        }

        a {
            font-size: 14px;
        }
    }

    footer {
        padding: 25px 0 100px;
        text-align: center;
    }

    .container-register {
        .error-field {
            input,
            select,
            .vue-tel-input {
                border-color: #FC4D4D;
                box-shadow: inset 0 0 0 1px #FC4D4D;
                transition: all .4s ease-in-out;
            }
            .validate-warning {
                color: #FC4D4D;
                font-size: 12px;
                transition: all .4s ease-in-out;
            }
        }
    }
</style>
